import React from "react";

import { StyledHubButton, StyledStack } from "./styles";

export const HubButtonGroupSlider = ({
  buttons,
  selected,
  setSelected = () => {},
  buttonProps,
  disabled,
  ...rest
}) => {
  const handleClick = (id) => setSelected(id);

  return (
    <StyledStack className="HubButtonGroupSlider-root" {...rest}>
      {buttons?.map((button) => (
        <StyledHubButton
          icon={button?.icon}
          iconProps={{ size: "12px" }}
          label={button.label}
          onClick={() => handleClick(button.id)}
          size="xsmall"
          disabled={disabled}
          {...(selected == button.id
            ? {
                variant: "contained",
                color: "grey",
                className: "HubButtonGroup-selected",
              }
            : {
                variant: "text",
                color: "neutral",
                className: "HubButtonGroup-button",
              })}
          {...buttonProps}
        />
      ))}
    </StyledStack>
  );
};

export default HubButtonGroupSlider;
